import * as React from 'react';
import * as InvoiceActions from './InvoiceActions';
import { connect } from 'react-redux';
import { Translate } from '../../shared/LanguageService';
import { Modal, Button, Row, Col, Table } from 'react-bootstrap';
import ICurrency from './ICurrency';
import moment from 'moment';

interface IViewPaymentsModalProps {
    invoiceId: number;
    closeModal(): void;
    paymentList: {
        payments: {
            id: number;
            date: any;
            type: string;
            registrationMethod: string;
            amountInclVAT: number;
            amountIncludingVATInInvoiceCurrency: number;
            comment: string;
            invoiceCurrency: ICurrency;
            legalEntityCurrency: ICurrency;
        }[];
        invoiceNumber: string;
    };
    actions: {
        getPayments(invoiceId: number);
    };
}

class ViewPaymentsModal extends React.Component<IViewPaymentsModalProps, any> {
    constructor(props: any, context: any) {
        super(props, context);
    }

    componentDidMount() {
        this.props.actions.getPayments(this.props.invoiceId);
    }

    countSumInInvoiceCurrency() {
        if (
            this.props.paymentList.payments &&
            this.props.paymentList.payments.some((p) => {
                return true;
            })
        ) {
            let amount = 0;

            this.props.paymentList.payments.forEach((p) => {
                amount += p.amountIncludingVATInInvoiceCurrency;
            });

            return `${this.props.paymentList.payments[0].invoiceCurrency.prefix}${amount}${this.props.paymentList.payments[0].invoiceCurrency.suffix}`;
        }

        return '0';
    }

    countSumInLegalEntityCurrency() {
        if (
            this.props.paymentList.payments &&
            this.props.paymentList.payments.some((p) => {
                return true;
            })
        ) {
            let amount = 0;

            this.props.paymentList.payments.forEach((p) => {
                amount += p.amountInclVAT;
            });

            return `${this.props.paymentList.payments[0].legalEntityCurrency.prefix}${amount}${this.props.paymentList.payments[0].legalEntityCurrency.suffix}`;
        }

        return '0';
    }

    render() {
        return (
            <Modal show={true} onHide={this.props.closeModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {Translate('invoice-history/view-payments-modal/title')}{' '}
                        {this.props.paymentList.invoiceNumber}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table responsive>
                        <thead>
                            <tr>
                                <th>
                                    {Translate(
                                        'invoice-history/view-payments-modal/table/date/header'
                                    )}
                                </th>
                                <th>
                                    {Translate(
                                        'invoice-history/view-payments-modal/table/payment-type/header'
                                    )}
                                </th>
                                <th>
                                    {Translate(
                                        'invoice-history/view-payments-modal/table/registration-type/header'
                                    )}
                                </th>
                                <th>
                                    {Translate(
                                        'invoice-history/view-payments-modal/table/comment/header'
                                    )}
                                </th>
                                {this.props.paymentList.payments &&
                                    this.props.paymentList.payments.some(
                                        (p) =>
                                            p.amountIncludingVATInInvoiceCurrency &&
                                            p.amountIncludingVATInInvoiceCurrency > 0
                                    ) && (
                                        <th>
                                            {Translate(
                                                'invoice-history/view-payments-modal/table/sum-incl-vat/header'
                                            )}
                                        </th>
                                    )}
                                <th>
                                    {Translate(
                                        'invoice-history/view-payments-modal/table/sum-incl-vat/header'
                                    )}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.paymentList.payments &&
                                this.props.paymentList.payments.map((p) => (
                                    <tr key={p.id}>
                                        <td>{moment(p.date).format('L')}</td>
                                        <td>{Translate(p.type)}</td>
                                        <td>{Translate(p.registrationMethod)}</td>
                                        <td>{p.comment}</td>
                                        {this.props.paymentList.payments &&
                                            this.props.paymentList.payments.some(
                                                (p) =>
                                                    p.amountIncludingVATInInvoiceCurrency &&
                                                    p.amountIncludingVATInInvoiceCurrency > 0
                                            ) && (
                                                <td>
                                                    {p.invoiceCurrency.prefix}
                                                    {p.amountIncludingVATInInvoiceCurrency}
                                                    {p.invoiceCurrency.suffix}
                                                </td>
                                            )}
                                        <td>
                                            {p.legalEntityCurrency.prefix}
                                            {p.amountInclVAT}
                                            {p.legalEntityCurrency.suffix}
                                        </td>
                                    </tr>
                                ))}
                            <tr>
                                <td colSpan={4} />
                                {this.props.paymentList.payments &&
                                    this.props.paymentList.payments.some(
                                        (p) =>
                                            p.amountIncludingVATInInvoiceCurrency &&
                                            p.amountIncludingVATInInvoiceCurrency > 0
                                    ) && (
                                        <td>
                                            <strong>{this.countSumInInvoiceCurrency()}</strong>
                                        </td>
                                    )}
                                <td>
                                    <strong>{this.countSumInLegalEntityCurrency()}</strong>
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.props.closeModal} bsStyle="default">
                        {Translate('invoice-history/view-payments-modal/footer/close')}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        paymentList: state.invoices.payments
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            getPayments: (invoiceId: number) => dispatch(InvoiceActions.getPayments(invoiceId))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewPaymentsModal);
